export type GradeResponse = {
  data: { options: Array<Grade> };
};

type Grade = {
  key: string;
  order: number;
  label: string;
  string: string;
  group?: number;
};

export class GradeModel {
  private grade: Grade;

  constructor(grade: Grade) {
    this.grade = grade;
  }

  get key() {
    return this.grade?.key || "";
  }

  get order() {
    return this.grade?.key || 0;
  }

  get label() {
    return this.grade?.label || "";
  }

  get string() {
    return this.grade?.string || "";
  }

  get group() {
    return this.grade?.group || 0;
  }
}

/**** Factory *****/
export function newGradeModel(params: Partial<Grade>) {
  return new GradeModel({
    key: "grade-key",
    order: 0,
    label: "Grade Label",
    string: "Grade String",
    group: 1,
    ...params,
  } satisfies Grade);
}
